import { Styleboard } from 'features/Styleboard/types'

export interface Notification {
  id: string
  message: string
  type: 'success' | 'error'
  notification: NotificationType
}
export enum NotificationType {
  PUT_PROFILE_SUCCESS = 0,
  PUT_PROFILE_FAILED = 1,
}

export interface MyProfileState {
  profile?: Profile
  isProfileLoading: boolean
  isProfileLoaded: boolean
  isProfileLoadingFailed: boolean
  isUploadingImageLoading: boolean
  hasUploadingImageSuccess: boolean
  hasUploadingImageFailed: boolean
  notifications: [Notification] | []
}

export interface Profile {
  image: string
  defaultImage: string
  userName: string
  type: string
  id: string
}

export interface MyStyleboards {
  styleboards: Styleboard[]
  _links: {
    next: {
      href: string
    }
  }
}
